import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { useSearchParams } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";

import AcademicDetails from "../components/academic/AcademicDetails";
import Overview from "../components/academic/Overview";
import Curriculum from "../components/academic/Curriculum";
import StudentDetails from "../components/academic/StudentDetails";
import AcademicSchedule from "../components/academic/AcademicSchedule";
import SchoolDress from "../components/academic/SchoolDress";
import ExamSchedule from "../components/academic/ExamSchedule";
// import FeesStructure from "../components/academic/FeesStructure";
import OtherVitalInfo from "../components/academic/OtherVitalInfo";

const Academics = () => {
    const [open, setOpen] = useState(false);

    const [searchParams] = useSearchParams();

    const tab = searchParams.get("tab") || "details";


    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />
            <Sidebar isOpen={open} close={() => setOpen(false)} />

            {/* HERO */}
            <div className="about-hero">
                <div className="about-overlay">
                    <h1>Academics</h1>
                    <Breadcrumb />
                </div>
            </div>

            {tab === "details" && <AcademicDetails />}
            {tab === "overview" && <Overview />}
            {tab === "curriculum" && <Curriculum />}
            {tab === "student" && <StudentDetails />}
            {tab === "timing" && <AcademicSchedule />}
            {tab === "dress" && <SchoolDress />}
            {tab === "exam" && <ExamSchedule />}
            {/* {tab === "fees" && <FeesStructure />} */}
            {tab === "other" && <OtherVitalInfo />}

            <Footer />
        </>
    );
};

export default Academics;